import { render } from "./index.vue?vue&type=template&id=55c4477b"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ProductionDetails/LoungeDetails/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55c4477b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55c4477b', __exports__)) {
    api.reload('55c4477b', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=55c4477b", () => {
    api.rerender('55c4477b', render)
  })

}


export default __exports__